import React from "react"
import { addValue, removeValue } from "../../../utils/filters"
import { useAlgoliaSearchState } from "../../controller/state"
import CheckboxFilterCategory from "../CheckboxFilterCategory"
import { FacetOption } from "../types"

const extractDiscountValue = (option: FacetOption) =>
  parseInt(option.value.split(":")[1])

const DiscountFilterOptions = () => {
  const { uiFilters, updateSearchParams } = useAlgoliaSearchState()
  const discounts = uiFilters?.discounts

  const handleFilterUpdate = (option: FacetOption, newValue: boolean) => {
    updateSearchParams((state) => {
      if (newValue) {
        return {
          ...state,
          discountPercentValues: addValue(
            state.discountPercentValues ?? [],
            extractDiscountValue(option)
          ),
        }
      } else {
        return {
          ...state,
          discountPercentValues: removeValue(
            state.discountPercentValues ?? [],
            extractDiscountValue(option),
            discounts
              ?.filter((x) => x.selected && !x.disabled)
              .map((x) => extractDiscountValue(x)) ?? []
          ),
        }
      }
    })
  }

  return (
    <CheckboxFilterCategory
      options={discounts ?? []}
      onOptionToggle={handleFilterUpdate}
    />
  )
}

export default DiscountFilterOptions
